module.exports = __webpack_public_path__ + "img/zalo.6fcdc5f8.png";